// PcHeader.tsx
'use client';

import { Button } from '@/components/ui/Button/Button';
import router from 'next/router';
import "@/styles/sections/header.scss";
import { useLanguage } from '@/context/LanguageContext';
import { PageSwitch } from './PageSwitch';
import { useState } from 'react';
const PcHeader = () => {
    const { t } = useLanguage();

    const [isSelected, setIsSelected] = useState(true);

    return (
            <div className="header-box">
                <div className="header-content">
                    {/* 왼쪽 로고 */}
                    <div className="logo">
                        <img
                            src="/codime-symbol-logotype-black.png"  // 로고 이미지 경로를 실제 경로로 수정해주세요
                            alt="Logo"
                        />
                    </div>

                    <PageSwitch isSelected={isSelected} onSelect={() => {
                        if (isSelected) {
                            window.location.href = 'https://influencer.codime.io/';
                        } else {
                            setIsSelected(!isSelected);
                        }
                    }} />

                    {/* 오른쪽 햄버거 메뉴 */}
                    <Button
                        otherClassName='btn-radius-100'
                        type="primary2"
                        size="small"
                        icon="none"
                        label={t.header.contactUs}
                        onClick={() => window.open('https://public.relate.so/p/forms/pzst8jlmfdxtahcw', '_blank')}
                        />
                </div>
            </div>
    );
};

export default PcHeader;